<template>
<div style="height:100%;">
	<div style="display: flex;position: relative;">
		<div class="left-box" :style="{'height': left_nav_height + 'px'}">
			<div class="first-title-box">群发消息</div>
			<div v-for="(item,index) in showTabData" :key="index" 
			:class="[item.status?'select_true':'']" 
			class="title-cell" @click="changeTab(item,index)">
				{{item.name}}
			</div>
			<!-- <div class="title-cell" ></div> -->
			<div v-if="showImgTxt.length > 0" class="first-title-box">智能图文</div>
			<div v-for="(item,index) in showImgTxt" :key="item.keys"
			:class="[item.status?'select_true':'']" 
			class="title-cell" @click="changeTab(item,index)">
				{{item.name}}
			</div>
			
			<div v-if="showFollow.length > 0" class="first-title-box">关注后回复</div>
			<div v-for="(item,index) in showFollow" :key="item.keys"
			:class="[item.status?'select_true':'']" 
			class="title-cell" @click="changeTab(item,index)">
				{{item.name}}
			</div>
		</div>
		
		<div style="flex: 1;">
			<router-view/>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'operMessIndex_',
	components: {},
	data() {
		return {
			left_nav_height: 1000, // 左侧导航的高度
			tabData: [
				{name:"本地图文模板管理", keys: "10", urls:"/materialList", status: false},
				{name:"草稿箱新建记录", keys: "21", urls:"/syncWxRecord", status: false},
				{name:"微信草稿箱/发表记录", keys: "3", urls:"/wxMaterialDrafts", status: false},
				{name:"定时群发记录", keys: "4", urls:"/massManage", status: false},
				{name:"微信发表记录", keys: "5", urls:"/publishRecord", status: false},
				{name:"群发数据统计", keys: "6", urls:"/sendMonthlyStatistics", status: false},
			],
			showTabData: [], // 显示用
			
			imgTxtTab: [
				{name:"智能图文管理", keys: "22", urls:"/imgTextPush", status: false},
			],
			showImgTxt: [], // 显示用
			
			followTab: [
				{name:"关注后回复", keys: "31", urls:"/followReply", status: false},
			],
			showFollow: [], // 显示用
		}
	},
	mounted() {
		let that = this
		
		that.left_nav_height = document.body.clientHeight - 70 - 50
		// console.log("operMessIndex-------------");
		// console.log("路由地址",this.$route.fullPath.split('?'));
		let r_path = this.$route.fullPath.split('?')
		let page_path = r_path[0]
		let tab_path = []
		
		console.log("get_navData",JSON.parse(localStorage.getItem("get_navData")));
		let n_data = JSON.parse(localStorage.getItem("get_navData"))
		// 找出当前路径所在的vues数据。
		n_data.forEach((res,index)=>{
			if(res.child.length != 0){
				res.child.forEach((res_a,index_a)=>{
					if(res_a.child.length != 0){
						res_a.child.forEach((res_c,index_c)=>{
							res_c.vues.forEach((res_e,index_e)=>{
								if(res_e.vue_url == page_path){
									tab_path = res_c.vues
								}
							})
							
						})
					}
					else if(res_a.vues.length > 0){ // 当没有三级导航，只有二级导航时
						// console.log(222222222,res.title);
						res_a.vues.forEach((res_c,index_c)=>{
							if(res_c.vue_url == page_path){
								tab_path = res_a.vues
							}
						})
					}
				})
				
			}
		})
		console.log("tab_path",tab_path);
		let tt_data = []
		let img_text_dara = []
		let follow_data = []
		// 根据后端配置的顺序进行排序
		tab_path.forEach((res,index)=>{
			// 群发消息
			that.tabData.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					tt_data.push(res_z)
				}
			})
			
			// 智能图文
			that.imgTxtTab.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					img_text_dara.push(res_z)
				}
			})
			
			// 关注后回复
			that.followTab.forEach((res_z,index_z)=>{
				if(res.vue_url == res_z.urls){
					follow_data.push(res_z)
				}
			})
		})
		// console.log("tt_data",tt_data);
		that.showTabData = tt_data
		
		that.showImgTxt = img_text_dara
		
		that.showFollow = follow_data
		
		// 接收子页面传过来的路径
		this.$bus.$on('tabPath',(e)=>{ // 通过这种方式能够应对更多的场景，比如点击顶部导航进入页面
			// console.log('微信草稿箱-tabPath-----',e)
			// 获取当前路由，并且对应标题高亮
			tt_data.forEach(res=>{
				res.status = false
				if(e.indexOf(res.urls) > -1){ // 用indexOf是担心获取的route带了?a=1之类的参数，用==来判断就不准了
					res.status = true
				}
			})
			
			img_text_dara.forEach(res=>{
				res.status = false
				if(e.indexOf(res.urls) > -1){
					res.status = true
				}
			})
			
			follow_data.forEach(res=>{
				res.status = false
				if(e.indexOf(res.urls) > -1){
					res.status = true
				}
			})
		})
	},
	
	methods:{
		changeTab(item,index){
			let that = this
			that.tabData.forEach(res=>{
				res.status = false
			})
			item.status = true
			// console.log(item);
			that.$router.push({path: item.urls})
		}
	},
}	
</script>

<style scoped>
.left-box {
	flex-shrink: 0;
	width: 190px;
	border-right: 1px solid #e8e8e8;
	margin-right: 20px;
	margin-left: -20px;
	padding-right: 10px;
	position: sticky;
	top: 85px;
	overflow-y: overlay;
}
.title-cell {
	font-size: 14px;
	height: 40px;
	line-height: 40px;
	cursor: pointer;
	padding-left: 20px;
	margin-bottom: 7px;
}
.title-cell:hover {
	background-color: #f2f3f5;
}

.select_true {
	/* color: #1d99ff; */
	color: #1890ff;
	background-color: #f2f3f5;;
}

.first-title-box {
	height: 40px;
	line-height: 40px;
	cursor: default;
	padding-left: 5px;
	margin-bottom: 7px;
	font-size: 16px;
}
</style>